export default "__VITE_ASSET__v5ANi$A6__"